// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"FK-z","inlineTitle":"GK-z","sponsoredAdsWrapper":"HK-z","marketplaceRecosWrapper":"IK-z"};